export default "__VITE_ASSET__44546528__"